/**
 * D40DivisionsTable Component
 * Container for two D40 division systems with expandable sections
 */

import React from 'react';
import { JatakaResponse } from '../../../../../models/api';
import { ExpandableSectionsContainer, ExpandableSection } from './ExpandableSectionsContainer';
import { AhirbhutamshaInfoTable } from './AhirbhutamshaInfoTable';
import { AshramaVashitaInfoTable } from './AshramaVashitaInfoTable';

export interface D40DivisionsTableProps {
  apiResponse?: JatakaResponse | null;
}

export const D40DivisionsTable: React.FC<D40DivisionsTableProps> = ({ apiResponse }) => {
  const sections: ExpandableSection[] = [
    {
      storageKey: 'd40-ahirbhutamsha-expanded',
      label: 'Ahirbhutamsha',
      component: <AhirbhutamshaInfoTable apiResponse={apiResponse} />,
    },
    {
      storageKey: 'd40-ashrama-expanded',
      label: 'Ashrama Vashita',
      component: <AshramaVashitaInfoTable apiResponse={apiResponse} />,
    },
  ];

  return <ExpandableSectionsContainer sections={sections} />;
};
